import * as yup from 'yup';

export const ParametersCompanyFormSchema = yup.object().shape({
  cp_keyword: yup.string().required('La palabra clave es requerida'),
  value: yup.string().required('El valor es requerido'),
  descripcion: yup.string().required('La descripción es requerida'),
  cp_module: yup.string().required('El módulo es requerido'),
  cp_name: yup.string().required('El nombre es requerido'),
});
